import gsap from 'gsap'
import barba from '@barba/core'
import lottieWeb from 'lottie-web'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isSafariBrowser, isFirefoxBrowser, updateBookingText, addTextToBooking } from './utilities'
import { initLenis, lenis, scrollToStart } from './lenis'
import { initAlpine } from './alpine'
import { formCollins } from './formCollins'
import { lottie } from './lottie'
import { gallery } from './gallery'
import { initSwiper } from './swiper'
import { splitType } from './splitType'
import { Navigation } from './navigation'
import { parallaxImages } from './parallaxImages'
import { parallaxFooter } from './parallaxFooter'
import { spinningDiscs, moveDarts, moveShufflepucks, bannerParallax, reduceLogo } from './animations'
import { initCursor, cursorEvents } from './cursor'
import { Events } from './events'
import { Load } from './load'
import { popup } from './popup'
import { datepicker } from './datepicker'
import { newYearsBanner } from './newYearsBanner'
import { newYearsModal } from './newYearsModal'
import { customBooking } from './customBooking'

const initBarba = () => {
	let animation
	const header = document.querySelector('.header')
	const navigation = new Navigation()
	const icon = document.querySelector('.transition__icon')
	const bars = document.querySelectorAll('.transition__bar span')
	const logoWords = document.querySelectorAll('.header__word')

	if (!isSafariBrowser()) {
		animation = lottieWeb.loadAnimation({
			container: icon,
			autoplay: true,
			renderer: 'svg',
			loop: true,
			path: '/lottie/cat.json'
		})
		animation.setSubframe(false)
	}

	barba.init({
		debug: true,
		timeout: 10000,
		prevent: ({ href }) => href.includes('contact'),
		schema: {
			prefix: 'data-load'
		},
		prevent: ({ el }) => {
			return (
				el.hasAttribute('data-barba-prevent')
			)
		},
		transitions: [
			{
				name: 'no-transition',
				sync: true,
				beforeOnce({ next }) {
					if (next.namespace === 'custom-booking') {
						return false;
					}
				},
				beforeLeave({ next }) {
					if (next.namespace === 'custom-booking') {
						return false;
					}
				},
			},
			{
				name: 'basic-transition',
				once(data) { },
				leave(data) {
					const done = this.async()
					const timeline = gsap.timeline()

					if (!isSafariBrowser()) {
						animation.goToAndPlay(0, true)
					}

					timeline.fromTo(
						bars,
						{ height: '0' },
						{
							duration: 1.05,
							height: '100%',
							stagger: 0.04,
							ease: 'power2.inOut',
							onComplete: done
						}
					)

					timeline.fromTo(
						icon,
						{
							opacity: 0
						},
						{
							duration: 0.3,
							opacity: 1
						},
						'-=0.5'
					)

					timeline.set(bars, { bottom: 'auto', top: 0 })
				},
				afterLeave() {
					scrollToStart()
					ScrollTrigger.killAll()
					navigation.closeNavigation()
					gsap.set(logoWords, { clearProps: 'all' })
				},
				enter(data) {
					htmx.process(data.next.container)
					header.dataset.theme = data.next.container.dataset.header
				},
				after(data) {
					const done = this.async()
					const timeline = gsap.timeline()

					timeline.fromTo(
						bars,
						{ height: '100%' },
						{
							duration: 1.05,
							height: '0',
							stagger: 0.04,
							ease: 'power2.inOut',
							onComplete: done
						}
					)

					timeline.fromTo(
						icon,
						{
							opacity: 1
						},
						{
							duration: 0.3,
							opacity: 0
						},
						'-=0.75'
					)

					timeline.set(bars, { bottom: 0, top: 'auto' })
				}
			}
		]
	})

	barba.hooks.once((data) => {
		header.dataset.theme = data.next.container.dataset.header

		initLenis()
		initAlpine()
		splitType()
		formCollins()
		gallery()
		initSwiper()
		parallaxImages()
		parallaxFooter()
		moveDarts()
		moveShufflepucks()
		spinningDiscs()
		initCursor()
		cursorEvents()
		bannerParallax()
		reduceLogo()
		Events()
		lottie()
		popup()
		updateBookingText()
		addTextToBooking()
		newYearsBanner()
		newYearsModal()
		datepicker()
		customBooking()

		new Load(1.5)
	})

	barba.hooks.after((data) => {
		formCollins()
		gallery()
		initSwiper()
		splitType()
		parallaxImages()
		parallaxFooter()
		moveDarts()
		moveShufflepucks()
		spinningDiscs()
		cursorEvents()
		bannerParallax()
		reduceLogo()
		Events()
		lottie()
		datepicker()
		newYearsBanner()

		new Load(0.75)

		const videos = document.querySelectorAll('video[autoplay]')

		videos.forEach((video) => video.play())
	})
}

export default initBarba
